import { FunctionComponent } from "react";
import type { Organization } from "@App/types";
import { Trans } from "react-i18next";
import { FontSize } from "@App/utils/tailwind/fontsize";

type HeroProps = {
  title: string;
  subtitle?: string | null;
  backgroundImage: string;
  backgroundPosition?: string;
  organization?: Organization | null;
  titleFontSize?: FontSize;
  subTitleFontSize?: FontSize;
  showPoweredBy?: boolean;
  mode?: "light" | "dark";
  overlay?: string;
};

export const Hero: FunctionComponent<HeroProps> = ({
  title,
  subtitle = null,
  backgroundImage,
  backgroundPosition = "bg-center md:bg-top",
  organization = null,
  titleFontSize = FontSize["md:text-3xl"],
  subTitleFontSize = FontSize["xl"],
  showPoweredBy = true,
  mode = "light",
  overlay = "",
}: HeroProps) => {
  const isDark = mode === "dark";
  const textColor = isDark ? "text-black" : "text-white";
  const logo = isDark ? "/images/brand/logoBlack.svg" : "/images/brand/logoWhite.svg";

  return (
    <div className={"h-64 relative"}>
      <div className="w-full h-full">
        <div
          className={`bg-${backgroundImage} bg-cover ${backgroundPosition ? backgroundPosition : ""} min-h-[217px] h-full`}
        />
      </div>
      <div
        className={`absolute top-0 left-0 flex justify-center items-center w-full h-full ${overlay}`}
      >
        <div className={`container ${textColor}`}>
          <div
            className={`font-serif ${titleFontSize ? titleFontSize : ""} text-3xl text-left w-full drop-shadow-md`}
          >
            <Trans i18nKey="hero.title" values={{ organization: organization?.name }}>
              {title}
            </Trans>
          </div>
          {subtitle && (
            <div
              className={`font-serif ${subTitleFontSize ? subTitleFontSize : ""} text-left w-full drop-shadow-md`}
            >
              {subtitle}
            </div>
          )}
          {showPoweredBy && (
            <div className="text-left w-full text-lg font-bold flex pt-3 drop-shadow-md">
              <div className="mr-2">powered by</div>
              <div>
                <img src={logo} className="w-28" alt="" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
